import React from 'react';


// import logins from '../../img/preview.jpg';
// import { AiFillGoogleCircle, AiOutlineLogin } from "react-icons/ai";
import { FcGoogle } from "react-icons/fc";
import { FiUserPlus } from "react-icons/fi";
import { AiTwotoneLock } from "react-icons/ai";


// import './Login.css'

import { useState } from 'react';
import {
    BrowserRouter as Router,

    NavLink,

    useLocation,
    useHistory
} from "react-router-dom";

import useAuth from './useAuth';
// import { ExitToApp, GolfCourseTwoTone, NearMe } from '@material-ui/icons';


const Login = () => {
    const { loginInUser, loading, error, user, googleLogin } = useAuth()

    const [loginDate, setLoginData] = useState({})
    const location = useLocation()
    const history = useHistory()
    const handleOnChange = e => {
        const field = e.target.name
        const value = e.target.value
        const newLoginData = { ...loginDate }
        newLoginData[field] = value
        setLoginData(newLoginData)
    }




    const handleOnSubmit = (e) => {
        e.preventDefault()
        loginInUser(loginDate.email, loginDate.password, location, history)

    }

    const handleGoogleLogin = () => {
        googleLogin(location, history)
    }



    return (


        <div>

            <div className="loginimage">

                <div class="containerlogin">

                    <div class="screen">
                        <div class="screen__content">

                            <form

                                data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-duration="1500"

                                onSubmit={handleOnSubmit} class="login">
                                <div class="social-login">
                                    <h3 className='text-dark'>Sign In WIth Google</h3>
                                    <button className='social-icons text-dark button-23' onClick={handleGoogleLogin}>
                                        Sign In <FcGoogle className='fs-1'></FcGoogle>

                                    </button>
                                </div>
                                <div class="login__field">
                                    <FiUserPlus></FiUserPlus>
                                    <input
                                        name='email'
                                        type="email" id="exampleInputEmail1"
                                        onChange={handleOnChange}
                                        placeholder='Type Your Email'
                                        class="login__input" />
                                </div>
                                <div class="login__field">
                                    <AiTwotoneLock></AiTwotoneLock>
                                    <input
                                        name='password'
                                        placeholder='Type Your Password'
                                        type="password"
                                        onChange={handleOnChange}
                                        class="login__input" />
                                </div>


                                <button class="button login__submit my-5 ">
                                    <span class="button__text">Login Now</span>
                                    <i class="button__icon fa fa-sign-in fs-5"></i>
                                </button>
                            </form>
                          
                            <NavLink
                                style={{ textDecoration: 'none' }}
                                to='/register'><p
                                    className='text-dark fs-5 fw-bolder'
                                >New User? Please <em style={{color:'#C89E5F '}} className='text-decoration-underline fw-bolder fs-4' >Register</em> </p>
                            </NavLink>

                        </div>
                        <div class="screen__background">
                            <span class="screen__background__shape screen__background__shape4"></span>
                            <span class="screen__background__shape screen__background__shape3"></span>
                            <span class="screen__background__shape screen__background__shape2"></span>
                            <span class="screen__background__shape screen__background__shape1"></span>
                        </div>
                    </div>
                </div>
                {loading && <div>
                    <div class="spinner-grow text-dark" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div><div class="spinner-grow text-dark" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>}
                {user?.email &&
                    <div class="alert alert-primary" role="alert">
                        User Created SuccessFulyy
                    </div>
                }
                {error &&
                    <div class="alert alert-warning" role="alert">
                        {error}
                    </div>
                }
            </div>
        </div>







    );
};

export default Login;